// extracted by mini-css-extract-plugin
export default {"overviewContainer":"styles_overviewContainer__g8Yh5","title":"styles_title__leFdK","overviewTable":"styles_overviewTable__J-6v8"};